import {Component, forwardRef, HostBinding, Input, Injectable, Output,EventEmitter} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {NgbDate} from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date";
import {
  NgbDateStruct, NgbCalendar, NgbCalendarIslamicUmalqura, NgbDatepickerI18n
} from '@ng-bootstrap/ng-bootstrap';

const noop = () => {
};

const I18N_VALUES = {
  weekdays: ['ن', 'ث', 'ر', 'خ', 'ج', 'س', 'ح'],
  months: ['محرم', 'صفر', 'ربيع الأول', 'ربيع الآخر', 'جمادى الأولى', 'جمادى الآخرة', 'رجب', 'شعبان', 'رمضان', 'شوال',
    'ذو القعدة', 'ذو الحجة']
};
@Injectable()
export class IslamicI18n extends NgbDatepickerI18n {

  getWeekdayShortName(weekday: number) {
    return I18N_VALUES.weekdays[weekday - 1];
  }

  getMonthShortName(month: number) {
    return I18N_VALUES.months[month - 1];
  }

  getMonthFullName(month: number) {
    return this.getMonthShortName(month);
  }
}

@Component({
  selector: 'app-date',
  templateUrl: './app-date.component.html',
  styleUrls: ['./app-date.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppDateComponent),
      multi: true
    }
  ]
})
export class AppDateComponent implements ControlValueAccessor {
  @Input() disabled = false;
  hijricalender: NgbCalendarIslamicUmalqura = new NgbCalendarIslamicUmalqura();
  model: NgbDateStruct;
  date: { year: number, month: number };
  selectdate='';
  otherdate='';
  datetype = 1;

  styledisplay = false;

  constructor(private calendar: NgbCalendar) { }

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  get value(): any {
    return this.selectdate;
  }

  onBlur() {
    this.onTouchedCallback();
  }

  changedate() {
    const Nselectdate = this.model.year+'-'+this.model.month+'-'+this.model.day;
    if(this.datetype === 2) {
      this.otherdate = Nselectdate;
      const ngbdate:NgbDate = new NgbDate(this.model.year,this.model.month,this.model.day);
      const convertDate = this.hijricalender.toGregorian(ngbdate);
      this.writeValue(convertDate.getFullYear()+'-'+(convertDate.getMonth()+1)+'-'+convertDate.getDate());
    } else {
      this.writeValue( Nselectdate);
      const convertDate = this.hijricalender.fromGregorian(new Date(this.model.year,this.model.month-1,this.model.day));
      this.otherdate = convertDate.year+'-'+convertDate.month+'-'+convertDate.day;
    }

  }

  setotherdate(date:any) {
    if(date === '' || !date) {
      this.otherdate = '';
      return;
    }
    const datearr = date.toString().split('-');
    if(datearr[0] > 1900) {
      const convertDate = this.hijricalender.fromGregorian(new Date(datearr[0],datearr[1]-1,datearr[2]));
      this.otherdate = convertDate.year+'-'+convertDate.month+'-'+convertDate.day;
    } else {
      const ngbdate:NgbDate = new NgbDate(datearr[0],datearr[1],datearr[2]);
      const convertDate = this.hijricalender.toGregorian(ngbdate);
      this.otherdate = convertDate.getFullYear()+'-'+(convertDate.getMonth()+1)+'-'+convertDate.getDate();
    }
    if(this.selectdate ==='') {
      this.otherdate = '';
    }
  }

  writeValue(date: any) {
    this.selectdate = date;
    this.setotherdate(date);
    this.onChangeCallback(this.selectdate);
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}

@Component({
  selector: 'ngbd-islamic-umalqura',
  templateUrl: './islamic.component.html',
  providers: [
    {provide: NgbCalendar, useClass: NgbCalendarIslamicUmalqura},
    {provide: NgbDatepickerI18n, useClass: IslamicI18n}

  ]
})
export class NgbdIslamicUmalqura extends AppDateComponent {
  name = 'Umalqura';
  @Input() getDate: NgbDateStruct;
  @Output() dateEmitter = new EventEmitter();
  changedate() {
    this.dateEmitter.next(this.model);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-date/app-date.component.ts